<div class="widget-container" #actionGridDiv>
  <main>
    <article #fs fullscreen-able [class.is-active]="isFullscreen" style="background-color: white;">
      <div>
        <icon-chart
          [headerConfig]="item.config?.widget_header_config"
          [rowDataLength]="rowData"
          [data]="rowData"
          [chartName]="'DataGrid'"
          [config]="actionGridDiv"
          [item]="item"
          [expand]="fs"
          [fullscreen]="isFullscreen"
          (expandCol)="expandCol($event)" 
          (screenChanges)="fullscreenChanges($event)"
        ></icon-chart>
      </div>

      <div *ngIf="loader" style="width: 100%; height: 80px;">
        <loading></loading>
      </div>

      <!-- Two-column layout -->
      <div class="grid-layout row">
        <!-- Left Panel: Create New Record -->
        <div class="left-panel col-12 col-md-4 col-lg-4 col-sm-12" style="padding: 0 10px;">
          <form #form="ngForm" (ngSubmit)="createNewRecord(form)">
            <div class="form-group du-action-filetype" *ngFor="let field of createFormFields">
              <input
                [type]="field.type === 'number' ? 'number' : 'text'"
                [placeholder]="field.placeholder"
                [(ngModel)]="newRecord[field.key]"
                [name]="field.key"
                [required]="field.required"
                (keydown)="field.type === 'number' ? preventInvalidKeys($event): ''"
                #ctrl="ngModel"
              />

              <!-- Validation messages -->
              <div class="error" *ngIf="ctrl.invalid && (ctrl.dirty || ctrl.touched)">
                <!-- Required -->
                <small *ngIf="ctrl.errors?.['required']">
                  {{ field.label || 'This field' }} is required
                </small>

                <!-- Number-specific validation -->
                <small *ngIf="field.type === 'number' && ctrl?.errors?.['min']">
                  Value must be greater than 0
                </small>
              </div>
            </div>

            <button
              mat-raised-button
              color="primary"
              class="du-btn-submit-filetype"
              type="submit"
              [class.disabled-btn-action]="form.invalid"
              [disabled]="form.invalid"
            >
              Create
            </button>
          </form>
        </div>

        <!-- Right Panel: Filetype Grid -->
        <div class="right-panel col-12 col-md-8 col-lg-8 col-sm-12" style="padding: 0;">
          <div class="header-actions">
            <h3>Filetype</h3>
          </div>

          <!-- AG-Grid Table -->
          <ag-grid-angular
            style="width:100%; height: 300px; font-family: 'Poppins';"
            [ngClass]="{'ag-theme-balham':true, 'DataGrid':isFullscreen}"
            class="editActionDataGrid"
            [suppressMovableColumns]="true"
            [rowStyle]="rowStyle"
            [rowHeight]="rowHeight"
            [suppressCellFocus]="true"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [animateRows]="true"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            [getRowStyle]="getRowStyle"
            (gridReady)="onGridReady($event)"
          ></ag-grid-angular>

          <!-- Footer Total -->
          <div class="footer-total" *ngIf="rowData && rowData.length > 0">
            <span>Total Payout:</span>
            <span class="total-value">
              ₹{{ getTotalPayout() | number:'1.2-2' }}
            </span>
          </div>

          <!-- No Data Message -->
          <div
            style="height: 200px; width: auto; display: flex; align-items: center; justify-content: center;"
            *ngIf="noData"
          >
            <span class="bg-texts">There is no data for this time period</span>
          </div>
        </div>
      </div>
    </article>
  </main>
</div>
